import { createActionCreator } from "common/ReduxUtils";

export enum FbaV3ActionTypes {
  RESET_FBA_V3_STATE = "RESET_FBA_V3_STATE",
}

export const resetFbaV3State = createActionCreator(FbaV3ActionTypes.RESET_FBA_V3_STATE);
